import { useContext, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { legacyDashboardURL } from '@helpers';
import { sitesQuery } from '@queries';
import { MoreHorizontalIcon, LayoutIcon, ListIcon } from '@svgs';

export const Template = ({ businessData, templateData }) => {
  const { t, i18n } = useTranslation();

  // Fetch template sites
  const { data: sitesData, isPending: sitesIsPending } = useQuery(
    sitesQuery({
      deleted: 0,
      published: 1,
      limit: 1,
      theme_id: templateData.theme_id,
    }),
  );

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  return (
    <div className="sb-template-item">
      <div>
        <Link
          to={`/dashboard/projects/${businessData?.id}/templates/${templateData?.id}/pages`}
        >
          <span className="img-contain">
            <img
              src={templateData.screenshot_thumbnail}
              alt={templateData.title}
              width="640"
              height="400"
            />
          </span>
        </Link>
      </div>
      <div className="sb-template-info sb-flex">
        <div>
          <p>{templateData.title}</p>
          {sitesIsPending && <p className="sb-subtext">...</p>}
          {!sitesIsPending && (
            <p className="sb-subtext">
              In use by {sitesData.meta.total_count} website
              {sitesData.meta.total_count != 1 ? 's' : ''}
            </p>
          )}
        </div>
        <div className="sb-template-options sb-options">
          <button
            className="sb-template-options-menu-trigger sb-options-trigger"
            onClick={() => setShowDropdownMenu(!showDropdownMenu)}
          >
            <MoreHorizontalIcon />
          </button>
          <div
            ref={dropdownMenu}
            className={
              'sb-template-options-menu sb-options-menu ' +
              (showDropdownMenu ? 'sb-show' : 'sb-hide')
            }
          >
            <div className="sb-options-menu-content">
              <Link
                to={`/dashboard/projects/${businessData.id}/templates/${templateData.id}/menus`}
                className="sb-template-options-edit sb-options-item"
              >
                <ListIcon />
                {t('Manage menus')}
              </Link>
              <a
                href={legacyDashboardURL(`/app/builder/${templateData.id}`)}
                className="sb-template-options-edit sb-options-item"
                target="_blank"
              >
                <LayoutIcon />
                {t('Open template editor')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
